
import './App.css';
import 'bootstrap/dist/css/bootstrap.min.css';

function Consept() {
  return (
    

<div className="bgTaka  position-relative overflow-hidden p-3 p-md-5 m-md-3 text-center bg-light">
    <div className="col-md-5 p-lg-5 mx-auto my-5">
      <h1 className="display-4  fw-normal">高本電業株式会社</h1>
      
    </div>

   
  </div>
  );
}

export default Consept;